import { reactive } from '@vue/composition-api';
import useUsers from '@/api/users';
import useCommonModal from '@/compositions/useCommonModal';
import { useMutation } from '@vue/apollo-composable';
import gql from '@/api/users/item.graphql';
import gqlObject from '@/api/objects/item.graphql';

const useProfileActions = (props, entity) => {
  const modalComposition = useCommonModal();

  const { mutate: updateObject } = useMutation(gqlObject.update);
  const { mutate: deleteObject } = useMutation(gqlObject.remove);

  const state = reactive({
    actions: [],
    selectedUserGroups: [],
    prevSelected: []
  });

  const processActions = handler => {
    state.actions.forEach(item => handler(item));
  };
  const isEnabled = targetObject => {
    return targetObject.enabled;
  };

  const handleToggleStatus = targetEntity => {
    let isEnabled = targetEntity.enabled;
    updateObject({
      input: {
        id: targetEntity.id,
        patch: {
          enabled: !isEnabled
        }
      }
    });
  };

  const handleDeleteProfile = targetEntity => {
    modalComposition.modal.show({
      component: () => import('@/components/app-entity/modals/AppDialog.vue'),
      bind: {
        nameModal: 'DeleteProfile'
      },
      slots: {
        default: {
          component: () =>
            import('@/components/app-entity/modals/DefaultConfirmation'),
          bind: {
            textDelete: 'Delete this profile completely?'
          },
          on: {
            delete() {
              deleteObject({
                input: {
                  id: targetEntity.id
                }
              }).then(() => {
                modalComposition.modal.hide('DeleteProfile');
              });
            },
            close() {
              modalComposition.modal.hide('DeleteProfile');
            }
          }
        }
      }
    });
  };

  const handleNotificationProfiles = targetEntity => {
    modalComposition.modal.show({
      component: () => import('@/components/app-entity/modals/AppDialog.vue'),
      bind: {
        nameModal: 'DeleteProfile'
      },
      slots: {
        default: {
          component: () =>
            import('@/components/app-entity/modals/ChangeNotificationProfiles'),
          bind: {
            profileId: targetEntity.id
          },
          on: {
            close() {
              modalComposition.modal.hide('DeleteProfile');
            }
          }
        }
      }
    });
  };

  const getActions = targetEntity => {
    state.actions = [
      {
        id: 'enable-disable',
        text: isEnabled(targetEntity) ? 'Disable' : 'Enable',
        icon: 'mdi-cancel',
        _enabled: true,
        handleAction: () => handleToggleStatus(targetEntity)
      },
      {
        id: 'change-profiles',
        text: 'Notification profiles',
        icon: 'mdi-bell',
        _enabled: true,
        handleAction: () => handleNotificationProfiles(targetEntity)
      },
      {
        id: 'delete',
        text: 'Delete',
        icon: 'mdi-delete',
        _enabled: true,
        handleAction: () => handleDeleteProfile(targetEntity)
      }
    ];

    return state.actions;
  };

  return {
    processActions,
    getActions
  };
};

export default useProfileActions;
